import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const getViewerAnalyticsWorkflowResults = createApi("ViewerAnalyticsWorkflowResultsSlice","GET");

const ViewerAnalyticsWorkflowResultsSlice = createSlice({
  name: 'ViewerAnalyticsWorkflowResultsSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getViewerAnalyticsWorkflowResults.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getViewerAnalyticsWorkflowResults.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getViewerAnalyticsWorkflowResults.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default ViewerAnalyticsWorkflowResultsSlice.reducer;